/**
 * MultiBuy Builder - utils.js
 * Shared helpers. No dependencies. Attaches to window.MB.utils
 */
(function (window) {
  'use strict';

  var MB = (window.MB = window.MB || {});

  function debounce(fn, wait) {
    var timer = null;
    return function debounced() {
      var args = arguments;
      var ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  var _uid = 0;
  function generateId(prefix) {
    _uid += 1;
    return (prefix || 'mb') + '-' + Date.now().toString(36) + '-' + _uid;
  }

  function escapeHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Money formatting. Cents (integer) -> localized string.
  // Uses Shopify.money_format when available (set globally by the theme
  // via {{ shop.money_format | json }} injected in the section), else falls
  // back to a plain decimal.
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    var moneyFormat = format || (window.MB.settings && window.MB.settings.moneyFormat) || '${{amount}}';

    function defaultTo(value, fallback) {
      return value == null || value === '' ? fallback : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) return '0';

      // Round display to whole currency units; retain cents in calculations.
      number = String(Math.round(number / 100.0));

      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';

      return dollars + cents2;
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = moneyFormat.match(placeholderRegex);

    if (!match) {
      return formatWithDelimiters(cents, 2);
    }

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, cents % 100 === 0 ? 0 : 2);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, cents % 100 === 0 ? 0 : 2, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return moneyFormat.replace(placeholderRegex, value);
  }

  function clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
  }

  function once(el, event, handler) {
    function wrapped(e) {
      el.removeEventListener(event, wrapped);
      handler(e);
    }
    el.addEventListener(event, wrapped);
  }

  function dispatch(name, detail, target) {
    (target || document).dispatchEvent(
      new CustomEvent(name, { detail: detail, bubbles: true })
    );
  }

  function shareLink(url, title) {
    url = url || window.location.href;
    title = title || document.title;
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        dispatch('multibuy:toast', { message: 'Link copied to clipboard' });
      });
    }
  }

  function lockScroll(lock) {
    document.documentElement.classList.toggle('mb-scroll-lock', !!lock);
  }

  function uniqueBy(arr, keyFn) {
    var seen = {};
    var out = [];
    for (var i = 0; i < arr.length; i++) {
      var k = keyFn(arr[i]);
      if (!seen[k]) {
        seen[k] = true;
        out.push(arr[i]);
      }
    }
    return out;
  }

  function parseJSONScript(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      console.error('[MultiBuy] Failed to parse JSON script #' + id, err);
      return null;
    }
  }

  MB.utils = {
    debounce: debounce,
    qs: qs,
    qsa: qsa,
    generateId: generateId,
    escapeHtml: escapeHtml,
    formatMoney: formatMoney,
    clamp: clamp,
    once: once,
    dispatch: dispatch,
    shareLink: shareLink,
    lockScroll: lockScroll,
    uniqueBy: uniqueBy,
    parseJSONScript: parseJSONScript
  };
})(window);
